/* GainsSteel® — signup success celebration (canvas fireworks + DOM confetti)
 * Triggered via window.gsSignupCelebrate() — see gs-topbar.js
 * Respects prefers-reduced-motion. */
(function () {
  var reduced =
    typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var layer, canvas, ctx, cHost;
  var COLORS = [
    '#ff6b1a',
    '#ff8b4c',
    '#ff9e6a',
    '#f5a623',
    '#ffffff',
    '#ffd591',
    '#4ade80',
    '#60a5fa',
    '#ff8aa8'
  ];

  var W,
    H,
    dpr = Math.max(1, Math.min(2, typeof window.devicePixelRatio === 'number' ? window.devicePixelRatio : 1));
  var particles = [];
  var rockets = [];
  var rafId = 0;
  var running = false;
  var endsAt = 0;

  function qs(id) {
    return document.getElementById(id);
  }

  function ensureDom() {
    layer = qs('gs-popup-celebration');
    canvas = qs('gs-celebration-canvas');
    cHost = qs('gs-confetti-host');
    return !!(layer && canvas && cHost);
  }

  function resize() {
    if (!canvas) return;
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function Particle(x, y, color) {
    var angle = Math.random() * Math.PI * 2;
    var speed = 1.5 + Math.random() * 5.5;
    this.x = x;
    this.y = y;
    this.vx = Math.cos(angle) * speed;
    this.vy = Math.sin(angle) * speed;
    this.color = color;
    this.life = 1;
    this.decay = 0.012 + Math.random() * 0.012;
    this.size = 1.6 + Math.random() * 2.2;
    this.drag = 0.985;
    this.glow = Math.random() < 0.35;
  }

  Particle.prototype.update = function () {
    var g = 0.06;
    this.vx *= this.drag;
    this.vy = this.vy * this.drag + g;
    this.x += this.vx;
    this.y += this.vy;
    this.life -= this.decay;
  };

  Particle.prototype.render = function () {
    if (this.life <= 0) return;
    ctx.globalAlpha = Math.max(0, this.life);
    if (this.glow) {
      ctx.shadowColor = this.color;
      ctx.shadowBlur = 12;
    } else {
      ctx.shadowBlur = 0;
    }
    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;
  };

  function Rocket(x, targetY, color) {
    this.x = x;
    this.y = H + 10;
    this.vx = (Math.random() - 0.5) * 1.2;
    this.vy = -(8 + Math.random() * 4);
    this.color = color;
    this.targetY = targetY;
    this.trail = [];
  }

  Rocket.prototype.update = function () {
    this.trail.push({ x: this.x, y: this.y });
    if (this.trail.length > 8) this.trail.shift();
    this.vy += 0.08;
    this.x += this.vx;
    this.y += this.vy;
    if (this.y <= this.targetY || this.vy >= 0) {
      this.explode();
      return false;
    }
    return true;
  };

  Rocket.prototype.render = function () {
    var i, t;
    for (i = 0; i < this.trail.length; i += 1) {
      t = this.trail[i];
      ctx.globalAlpha = (i / this.trail.length) * 0.6;
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(t.x, t.y, 2, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    ctx.shadowColor = this.color;
    ctx.shadowBlur = 12;
    ctx.fillStyle = '#fff';
    ctx.beginPath();
    ctx.arc(this.x, this.y, 2.8, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;
  };

  Rocket.prototype.explode = function () {
    var n = 50 + Math.floor(Math.random() * 40);
    var palette =
      Math.random() < 0.5
        ? [this.color]
        : [this.color, COLORS[(Math.random() * COLORS.length) | 0]];
    var i, c;
    for (i = 0; i < n; i += 1) {
      c = palette[(Math.random() * palette.length) | 0];
      particles.push(new Particle(this.x, this.y, c));
    }
  };

  function spawnConfetti(durationMs) {
    if (!cHost || reduced) return;
    cHost.innerHTML = '';
    var count = Math.min(80, Math.max(40, Math.floor(W / 14)));
    var shapes = ['gs-confetti--strip', 'gs-confetti--square', 'gs-confetti--disc', ''];
    var colorClasses = [
      'gs-confetti--orange',
      'gs-confetti--fg',
      'gs-confetti--amber',
      'gs-confetti--white',
      'gs-confetti--success',
      'gs-confetti--pink',
      'gs-confetti--blue'
    ];
    var i,
      el,
      cCl,
      sh,
      rnd = Math.random.bind(Math);

    function add(o) {
      requestAnimationFrame(function () {
        o.classList.add('is-on');
      });
    }

    for (i = 0; i < count; i += 1) {
      el = document.createElement('span');
      cCl = colorClasses[(rnd() * colorClasses.length) | 0];
      sh = shapes[(rnd() * shapes.length) | 0];
      el.className = ['gs-confetti', cCl, sh].filter(Boolean).join(' ');
      el.style.left = rnd() * 100 + '%';
      el.style.setProperty('--drift', rnd() * 200 - 100 + 'px');
      el.style.setProperty('--spin', rnd() * 1200 + 600 + 'deg');
      el.style.animationDuration = 3.2 + rnd() * 2.2 + 's';
      el.style.animationDelay = rnd() * (durationMs / 1000) * 0.6 + 's';
      cHost.appendChild(el);
      add(el);
    }
  }

  function clearConfetti() {
    if (cHost) cHost.innerHTML = '';
  }

  function loop() {
    if (!running || !ctx) return;
    ctx.globalAlpha = 1;
    ctx.fillStyle = 'rgba(0,0,0,0.18)';
    ctx.fillRect(0, 0, W, H);

    var i, alive;

    for (i = rockets.length - 1; i >= 0; i -= 1) {
      alive = rockets[i].update();
      rockets[i].render();
      if (!alive) rockets.splice(i, 1);
    }

    for (i = particles.length - 1; i >= 0; i -= 1) {
      particles[i].update();
      particles[i].render();
      if (particles[i].life <= 0 || particles[i].y > H + 20) particles.splice(i, 1);
    }

    if (performance.now() < endsAt - 800 && Math.random() < 0.08) {
      rockets.push(
        new Rocket(
          W * (0.15 + Math.random() * 0.7),
          H * (0.18 + Math.random() * 0.22),
          COLORS[(Math.random() * COLORS.length) | 0]
        )
      );
    }

    if (performance.now() < endsAt || particles.length || rockets.length) {
      rafId = requestAnimationFrame(loop);
    } else {
      stop();
    }
  }

  function fireBigOpener() {
    var ys = [H * 0.3, H * 0.22, H * 0.32];
    var xs = [W * 0.25, W * 0.5, W * 0.75];
    var i;

    function push(ix) {
      rockets.push(new Rocket(xs[ix], ys[ix], COLORS[(Math.random() * COLORS.length) | 0]));
    }

    for (i = 0; i < 3; i += 1) {
      (function (idx) {
        setTimeout(function () {
          push(idx);
        }, idx * 180);
      })(i);
    }
  }

  function start() {
    if (reduced) return;
    if (!ensureDom()) return;
    ctx = canvas.getContext('2d');
    if (running || !ctx) return;

    resize();
    running = true;
    layer.classList.add('gs-popup-celebration--on');
    endsAt = performance.now() + 6200;
    particles = [];
    rockets = [];

    fireBigOpener();
    spawnConfetti(6200);
    rafId = requestAnimationFrame(loop);

    setTimeout(function () {
      layer.style.transition = 'opacity 800ms ease';
    }, 5000);

    setTimeout(function () {
      layer.classList.remove('gs-popup-celebration--on');
    }, 6400);
  }

  function stop() {
    running = false;
    cancelAnimationFrame(rafId);
    setTimeout(function () {
      if (ctx && canvas) ctx.clearRect(0, 0, W || 800, H || 600);
      clearConfetti();
      if (layer) layer.style.transition = '';
    }, 900);
  }

  window.addEventListener('resize', resize);

  window.gsSignupCelebrate = function () {
    start();
  };
})();